import { httpService } from '@/core/index';
import { translationUrl } from '@/api/sources';
import LangJs from 'lang.js';
import { useAuthStore } from '@/stores/auth';

export default class Lang {
  constructor() {
    this._lang = null;
    this._country = null;
    this._locale = null;
    this._loaded = [];
  }

  trans(key, replacements) {
    return this._lang.trans(key, replacements);
  }

  transPlural(key, choice, values = null) {
    return this._lang.choice(key, choice, values);
  }

  choice(key, plural, replacements) {
    return this._lang.choice(key, plural, replacements);
  }

  async changeLocale(locale) {
    if (this._loaded.indexOf(locale) < 0) {
      this._lang.setMessages(await this._loadLocale());
      this._loaded.push(locale);
    }

    this._lang.locale = locale;
  }

  async load(locale, messages, country = null) {
    this._loaded.push(locale);
    this._locale = locale;
    this._country = country;
    useAuthStore().setLocale(locale);

    this._lang = new LangJs({
      locale: locale,
      messages: messages,
      fallback: 'lt',
    });
  }

  async _loadLocale() {
    const response = await httpService.get(translationUrl());
    return response.data.data;
  }

  getLocale() {
    return this._locale;
  }

  getCountry() {
    return this._country;
  }
}
